export enum ServiceAnnouncementStateEnum {
  DEFAULT = 'default',
  RESOLVED = 'resolved',
  CLOSED = 'closed',
  UNRESOLVED = 'unresolved',
}
